
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refunds",
      function () {
        return require("private-next-pages/refunds.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refunds"])
      });
    }
  